<template>
  <Nav-bar :has_back="true" :has_right="false" title="电站详情"></Nav-bar>
  <div class="top-margin"></div>
  <van-swipe
    class="my-swipe"
    :autoplay="3000"
    lazy-render
    indicator-color="white"
  >
    <van-swipe-item v-for="item in state.stationDetails.images" :key="item">
      <img :src="getFullImageUrl(item)" class="img" />
    </van-swipe-item>
  </van-swipe>
  <div class="charging-container">
    <van-tabs
      title-active-color="#0082FF"
      color="#0082FF"
      v-model:active="active"
    >
      <van-tab title="电站信息">
        <div class="car-container">
          <div class="display_flex">
            <div
              class="block"
              :class="state.stationDetails.category"
              style="margin-top: 2px"
            >
              {{ categoryStatus[state.stationDetails.category] }}
            </div>
            <span class="font-bold t-f16-c1a m-l-5">{{
              state.stationDetails.name
            }}</span>
          </div>
          <div class="display_flex m-t-10">
            <img
              src="@/images/stataion_detail_address.png"
              class="small-icon"
            />
            <span class="t-f13-c66 m-l-5" style="width:80%">{{
              state.stationDetails.address
            }}</span>
          </div>
          <div class="display_flex m-t-10">
            <img src="@/images/station_detail_phone.png" class="small-icon" />
            <span class="t-f13-c66 m-l-5">{{
              state.stationDetails.phone
            }}</span>
          </div>
          <div class="navigation" @click="openSdkLocation()">
            <img
              src="@/images/station_navigation.png"
              class="navigation-icon"
            />
            <div class="t-f12-c1a font-bold">{{ state.getDance }} km</div>
          </div>
        </div>
        <div class="station-detail-info">
          <div class="display_flex rate block-v">
            <span class="t-f14-c1a">充电费率</span>
            <span class="t-f14-c66 m-l-15"
              >{{ state.stationDetails.floor_price }}-{{
                state.stationDetails.ceiling_price
              }}
              元／度 （含充电服务费）</span
            >
          </div>
          <div class="time-block display_flex block-v">
            <span class="t-f14-c1a">营业时间</span>
            <div class="time-list">
              <div class="t-f14-c66">工作日 08:00-20:00</div>
              <div class="t-f14-c66">节假日 08:00-20:00</div>
            </div>
          </div>
          <div class="display_flex rate">
            <span class="t-f14-c1a">运营商</span>
            <span class="t-f14-c66" style="margin-left: 30px">{{
              state.operatorName
            }}</span>
          </div>
        </div>
      </van-tab>
      <van-tab title="电桩列表">
        <van-empty
          description="暂无充电桩"
          v-if="state.chargeList.length == 0"
        />
        <div
          class="charge-item"
          v-else
          @click="toChargeDetails(list.id)"
          v-for="list in state.chargeList"
          :key="list"
        >
          <div class="display_flex">
            <span class="font-bold t-f16-c1a"
              >{{ list.charging_pile.serial_number }}{{ list.name }}</span
            >
            <img
              src="../../images/charge_vip_icon.png"
              class="v_icon"
              v-if="list.vip_user"
            />
            <div class="item-block leisure m-l-10" :class="list.status">
              {{ list.statusName }}
            </div>
          </div>
          <div class="t-f13-c66 m-t-5">
            {{ list.charging_pile.pile_type == "dc" ? "直流" : "交流" }}
          </div>
          <div
            class="lock_btn"
            @click.stop="openLock(list.charging_station_parking_lock)"
            v-if="list.charging_station_parking_lock != ''"
          >
            降锁
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
// import Swipe from "../../components/Swipe.vue";
import { useRouter } from "vue-router";
import { reactive, ref } from "vue";
import request from "@/api/request";
import ordersData from "@/utils/data.js";
import { useStore } from "vuex";
import httpHelper from "@/helpers/http_helper";
import wx from "weixin-js-sdk";
import { Toast } from 'vant';
let router;
let storeContext; //上下文
let state;
let active = ref(0);
export default {
  components: {
    NavBar: NavBar,
    // Swipe: Swipe,
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      //桩列表
      active.value = 0;
    }
    stationDetailsApi(router.currentRoute.value.params.id);
    chargersList(router.currentRoute.value.params.id);
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "ChargeDetails") {
      //判断是从哪个路由过来的
      to.meta.isBack = true;
    }
    next();
  },
  setup() {
    state = reactive({
      stationDetails: {},
      stationDance: "",
      chargeList: [],
      operatorName:""
    });
    storeContext = useStore();
    const categoryStatus = {
      self_run: "自营",
      info: "第三方",
      third_party: "第三方",
    };

    router = useRouter();
    //电站详情
    stationDetailsApi(router.currentRoute.value.params.id);
    chargersList(router.currentRoute.value.params.id);
    //跳转桩详情
    function toChargeDetails(id) {
      router.push(`/station/charge_details/${id}`);
    }

  function openLock(data){
     Toast.loading({
        message: "降锁中...",
        loadingType: "spinner",
        icon: "bulb-o",
        forbidClick: true,
      });
     request
    .putOpenLock(data.id)
    .then((res) => {
     if(!res.data.result){
       Toast("降锁异常!")
     }
    })
  
    
  }
  function getFullImageUrl(img){
  const domain = window.location.origin.replace("-webapp", "")+  img 
    return domain;
}
    return {
      toChargeDetails,
      categoryStatus,
      state,
      getFullImageUrl,
      active,
      openLock,
      openSdkLocation,
    };
  },
};

function stationDetailsApi(id) {
  httpHelper.showLoading();
  request
    .getIndexStationDetails(id)
    .then((res) => {
      httpHelper.hideLoading();
      state.stationDetails = res.data;
      state.operatorName  = res.data.service_provider.name
      //get  state  userposition
      if (storeContext.state.UserPosition != "") {
        let lat = storeContext.state.UserPosition.lat;
        let lng = storeContext.state.UserPosition.lng;
        state.getDance = getDance(
          res.data.latitude,
          res.data.longitude,
          lat,
          lng
        );
      } else {
        state.getDance = " --";
      }
    })
    .catch(() => {
      httpHelper.hideLoading();
    });
}
function chargersList(id) {
  request
    .getChargersList(id)
    .then((res) => {
      state.chargeList = formatData(res.data.results);
    })
  
}
function openSdkLocation() {
  wx.openLocation({
    latitude: state.stationDetails.latitude, // 纬度，浮点数，范围为90 ~ -90
    longitude: state.stationDetails.longitude, // 经度，浮点数，范围为180 ~ -180
    name: state.stationDetails.name, // 位置名。
    address: state.stationDetails.address,
  });
}
function formatData(list) {
  for (let i = 0; i < list.length; i++) {
    list[i].statusName = ordersData.chargeStatus(list[i].status);
  }
  return list;
}

function getDance(lat1, lng1, lat2, lng2) {
  var radLat1 = (lat1 * Math.PI) / 180.0;
  var radLat2 = (lat2 * Math.PI) / 180.0;
  var a = radLat1 - radLat2;
  var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137;
  s = Math.round(s * 10000) / 10000;
  return s.toFixed(2);
}
</script>

<style lang="scss" scoped>
::v-deep.van-swipe {
  //  margin: 0px;
  width: 100%;
}
::v-deep.van-swipe-item{
  height: 200px;
}
.img {
  width: 100%;
  height: 100%;
}
.lock_btn {
  background-color: #ecf6ff;
  font-size: 12px;
  border-radius: 15px;
  position: absolute;
  right: 30px;
  top: 50%;
  padding: 5px 10px;
  transform: translateY(-50%);
}
.item-block {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  border-radius: 5px;

  padding: 2px 2px 0px 2px;
}
.car-container {
  background: #fff;
  padding: 20px;
  position: relative;
  margin-top: 1px;
}
.navigation {
  position: absolute;
  bottom: 20px;
  right: 27px;
  text-align: center;
}
.navigation-icon {
  width: 30px;
  height: 30px;
}
.tip-bolck {
  border: 1px solid #0082ff;
  color: #0082ff;
}
.charge-type-block {
  border: 1px solid #ebebeb;
  color: #666;
  height: 15px;
}
.station-detail-info {
  margin-top: 10px;
  background: #fff;
  padding: 0 20px;
}
.block-v {
  border-bottom: 1px solid #ebebeb;
}
.time-block {
  padding: 15px 0px;
}
.rate {
  line-height: 50px;
  position: relative;
}
.time-list {
  margin-left: 15px;
}
.charge-item {
  margin-top: 10px;
  background: #fff;
  position: relative;
}
.charge-item {
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
}
.leisure {
  border: 1px solid #0082ff;
  color: #0082ff;
}
.v_icon {
  width: 28px;
  height: 16px;
  vertical-align: middle;
  flex-shrink: 0;
  margin: auto 0px;
  margin-left: 5px;
}
.available {
  border: 1px solid #00b68a !important;
  color: #00b68a !important;
}
.offline {
  border: 1px solid #999999 !important;
  color: #999999 !important;
}
.charged {
  border: 1px solid #0082ff !important;
  color: #0082ff !important;
}
.maintaining {
  border: 1px solid #fb0006 !important;
  color: #fb0006 !important;
}
.charging {
  border: 1px solid #ff8f00 !important;
  color: #ff8f00 !important;
}
</style>